import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Photo } from "./Photo";

export const ImageReveal = ({ src, alt, label, tone = "brunswick", testId, className = "", parallax = 36 }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-parallax, parallax]);

  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.div
        className="h-full w-full"
        initial={{ clipPath: "inset(14% 9% 14% 9%)", opacity: 0.35, scale: 1.08 }}
        whileInView={{ clipPath: "inset(0% 0% 0% 0%)", opacity: 1, scale: 1 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 1.3, ease: [0.16, 1, 0.3, 1] }}
      >
        <motion.div className="-mt-[4%] h-[112%] w-full" style={{ y }}>
          <Photo src={src} alt={alt} label={label} tone={tone} testId={testId} />
        </motion.div>
      </motion.div>
    </div>
  );
};
